module.exports = __webpack_public_path__ + "img/77.5.COD.f8f739b2.png";